import React from 'react'
import ModernizrWebpSupportScript from './ModernizrWebpSupportScript'
import googleOptimizeLink from './googleOptimize'
import ogImage from './og-image.jpg'

const CommonHead: React.FC<Head.Props> = props => {
  const {
    title = 'TAG Livros | Clube de Assinatura de Livros',
    description = 'A TAG é um Clube de Assinatura de Livros que envia, a cada mês, um livro surpresa. Conheça nossos kits e viva a experiência de um clube do livro!',
    image = ogImage,
    shouldIndex = true,
    children,
  } = props

  return <>
    <title >{title}</title>
    <script
      defer
      src={ googleOptimizeLink }
    />
    <ModernizrWebpSupportScript />
    <meta
      content={ description }
      name="description"
    />
    <meta
      content={ image }
      name="image"
    />
    {process.env[ 'GATSBY_ACTIVE_ENV' ] === 'prd' &&
    <meta
      content={ process.env[ 'GATSBY_GOOGLE_SEARCH_ID' ] }
      name="google-site-verification"
    />}
    <meta
      name="robots"
      content={ shouldIndex ? 'index, follow' : 'none' }
    />
    {children}
  </>
}
namespace Head {
  export interface Props {
    title?: string
    description?: string
    image?: string
    children?: React.ReactNode
    shouldIndex?: boolean
  }
}

export default CommonHead
